import React from "react";
import { Auth, I18n } from "aws-amplify";
import { SignUp } from "aws-amplify-react";
import { withRouter } from "react-router-dom";
import {
  FormSection,
  FormField,
  SectionHeader,
  SectionBody,
  SectionFooter,
  Button,
  Link,
  Input,
  InputLabel,
  SectionFooterPrimaryContent,
  SectionFooterSecondaryContent
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import { CustomSuccessSignUp } from "./CustomSuccessSignUp";

import { AuthContext } from "../AuthContext";

class CustomSignUp extends SignUp {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = { showSuccess: false };
  }

  // this method has been copied and pasted from SignUp
  // with the modifcation of Auth.signUp's this.changeState
  // being called with "checkEmail"
  signUp() {
    if (!this.inputs.dial_code) {
      this.inputs.dial_code = this.getDefaultDialCode();
    }
    const validation = this.validate();
    if (validation && validation.length > 0) {
      return this.error(
        `The following fields need to be filled out: ${validation.join(", ")}`
      );
    }
    if (!Auth || typeof Auth.signUp !== "function") {
      throw new Error(
        "No Auth module found, please ensure @aws-amplify/auth is imported"
      );
    }

    let signup_info = {
      username: this.inputs.username,
      password: this.inputs.password,
      attributes: {
        "custom:signUpSite": window.location.hostname
      }
    };

    const inputKeys = Object.keys(this.inputs);
    const inputVals = Object.values(this.inputs);

    inputKeys.forEach((key, index) => {
      if (
        !["username", "password", "checkedValue", "dial_code"].includes(key)
      ) {
        if (
          key !== "phone_line_number" &&
          key !== "dial_code" &&
          key !== "error"
        ) {
          const newKey = `${this.needPrefix(key) ? "custom:" : ""}${key}`;
          signup_info.attributes[newKey] = inputVals[index];
        } else if (inputVals[index]) {
          signup_info.attributes["phone_number"] = `${
            this.inputs.dial_code
          }${this.inputs.phone_line_number.replace(/[-()]/g, "")}`;
        }
      }
    });

    // signs them user up then immdediately signs them in
    // then redirect them to the home page
    Auth.signUp(signup_info)
      .then(() => Auth.signIn(signup_info.username, signup_info.password))
      .then(() => this.context.setIsAuthenticated(true))
      .then(() => {
        this.setState({ showSuccess: true });
        setTimeout(() => {
          this.props.history.push("/");
        }, 4000);
      })
      .catch(err => this.error(err));
  }

  showComponent(theme) {
    const { hide } = this.props;
    if (hide && hide.includes(CustomSignUp)) {
      return null;
    }
    if (this.checkCustomSignUpFields()) {
      this.signUpFields = this.props.signUpConfig.signUpFields;
    }
    this.sortFields();

    if (this.state.showSuccess) {
      return <CustomSuccessSignUp theme={theme} />;
    }

    return (
      <FormSection theme={theme}>
        <SectionHeader theme={theme}>{I18n.get(this.header)}</SectionHeader>
        <SectionBody theme={theme}>
          {this.signUpFields.map(field => (
            <FormField theme={theme} key={field.key}>
              {field.required ? (
                <InputLabel theme={theme}>{I18n.get(field.label)} *</InputLabel>
              ) : (
                <InputLabel theme={theme}>{I18n.get(field.label)}</InputLabel>
              )}
              <Input
                autoFocus={
                  this.signUpFields.findIndex(f => {
                    return f.key === field.key;
                  }) === 0
                    ? true
                    : false
                }
                placeholder={I18n.get(field.placeholder)}
                theme={theme}
                type={field.type}
                name={field.key}
                key={field.key}
                onChange={this.handleInputChange}
              />
            </FormField>
          ))}
        </SectionBody>
        <SectionFooter theme={theme}>
          <SectionFooterPrimaryContent theme={theme}>
            <Button onClick={this.signUp} theme={theme}>
              {I18n.get("Create Account")}
            </Button>
          </SectionFooterPrimaryContent>
          <SectionFooterSecondaryContent theme={theme}>
            {I18n.get("Have an account? ")}
            <Link theme={theme} onClick={() => this.changeState("signIn")}>
              {I18n.get("Sign in")}
            </Link>
          </SectionFooterSecondaryContent>
        </SectionFooter>
      </FormSection>
    );
  }
}

export default withRouter(CustomSignUp);
